---
nb:
  notification_system:
    instant_sender:
      associated_event: Tilknyttet hendelse
      capacity_used: Kapasitet brukt
      current_deviation: Nåværende avvik
      current_energy: Nåværende energi
      deviation_value: "%{deviation}%"
      energy_mwh: "%{energy} MWh"
      event_component: Komponent
      event_started: Startet
      event_status: Status
      maximum_capacity: Maksimal kapasitet
      optimization_initiated: Produksjonsoptimaliseringen har blitt igangsatt og markedsinnsending vil følge.
      percentage: "%{percentage}%"
      reservoir_energy_status: Magasinenergi status
      threshold_setting: Terskelinnstilling
      threshold_value: "±%{threshold}%"
      toast_title: InstantSender utløst for %{power_plant_name}
      trigger_time: Utløsertidspunkt
      trigger_type: Utløsertype
      trigger_types:
        manual: Manuell utløser
        other: Annet
        water_level_high: Høy vannstand
        water_level_low: Lav vannstand
      triggered_for: InstantSender har blitt utløst for %{power_plant_name}
      view_details: Se detaljer i Portalens produksjonssimulerings-plan.
      water_level: Vannstand
      water_level_masl: "%{level} moh"
